module.exports = "<button class='btn--link' (click)='onBack()'><em>Back</em></button>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/power-planner/power-planner/src/app/core.module/location-back.component/location-back.component.html
// module id = ../../../../../src/app/core.module/location-back.component/location-back.component.html
// module chunks = main